module.exports = __webpack_public_path__ + "img/player-track-next-blue.e5545a1d.svg";